import React, { useEffect, useState } from 'react';
import {
  Box,
  Divider,
  TextField,
  Paper,
  Typography,
  IconButton,
  InputAdornment,
  useTheme,
  Button,
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { forgotPasswordSchema } from '../../../helpers/validations/forgotPasswordValidation';
import { controlPanelAdminForgotPassword, studentForgotPassword } from '../../../api/login/loginService';
import { ROUTES } from '../../../constants/routes';
import { useSelector } from 'react-redux';

const ForgotPassword = ({ setStep, setFormData }) => {
  const currentLocation = useLocation();
  const routeName = currentLocation.pathname;
  const [showPassword, setShowPassword] = useState(false);
  const forgotToLoginMap = {
    [ROUTES.ADMINFORGOTPASSWORD]: ROUTES.ADMINSIGNIN,
  };

  const backToLoginPath = forgotToLoginMap[routeName] || ROUTES.STUDENTSIGNIN;

  // const { setStep, step } = props;
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(forgotPasswordSchema),
  });
  const handleTogglePassword = () => setShowPassword(!showPassword);
  const customColors = useSelector(state => state.theme.customColors);
  const onSubmit = async data => {
    try {
      const formData = {
        emailId: data.email,
      };
      let result;
      switch (routeName) {
        case '/admin-forgot-password':
          result = await controlPanelAdminForgotPassword(formData);
          break;
        default:
          result = await studentForgotPassword(formData);
          break;
      }
      debugger
      if(result && result?.error === true){
        //showSnackbar(`User not found with this ${data.email}`, 'info');
        return 
      }
      setStep(2);
       setFormData({
        email: data.email,
        newPassword: data.password,
      });
      // toast.success(`OTP sent to ${data.email}`);
      //showSnackbar("OTP sent to registered email id", 'success');
    } catch (err) {
      //  toast.error(err.message  || 'Something went wrong. Please try again.');
      //showSnackbar(err.message || 'Something went wrong. Please try again.', 'error');
    }
  };

  const onFormError = formErrors => {
    const firstError = Object.values(formErrors)[0];
    if (firstError?.message) {
      // toast.error(firstError.message);
      //showSnackbar(firstError.message, 'error');
    }
  };

  return (
       <Paper sx={{ maxWidth: 400, p: 4, mx: "auto", mt: 10 }}>
      <Typography variant="h5" mb={2}>Forgot Password</Typography>
      <form onSubmit={handleSubmit(onSubmit, onFormError)} noValidate>
        <TextField
          fullWidth
          size='small'
          label="UserName"
          variant="filled"
          sx={{ mb: 2 }}
          error={!!errors.email}
          helperText={errors.email?.message}
          {...register('email')}
          className="cp-form-control input-focus"
        />
        <TextField
          fullWidth
          size='small'
          label="password"
          name="password"
          variant="filled"
          className="cp-form-control input-focus"
          error={!!errors.password}
          {...register('password')}
        />
        <Button variant="contained" type='submit' fullWidth sx={{ mt: 2 }}
          disabled={isSubmitting}
        // {isSubmitting ? 'Logging in...' : 'Log In'}
        >Submit</Button>
        <Box textAlign="right" mt={1}>
          <Link to={ROUTES.ADMINSIGNIN}>Login?</Link>
        </Box>
      </form>
    </Paper>
  );
};

export default ForgotPassword;
